<ng-template #loadingGeneral>
  <mat-spinner class="center"></mat-spinner>
  <h3 class="center">
    <ng-container
      *ngIf="currentStatus === contractStatuses.approvalWaiting && (selectedStatus !== contractStatuses.rejected && selectedStatus !== contractStatuses.expired)">
      Accepting contract...
    </ng-container>
    <ng-container
      *ngIf="currentStatus === contractStatuses.approvalWaiting && selectedStatus === contractStatuses.rejected">
      Rejecting contract...
    </ng-container>
    <ng-container
      *ngIf="(currentStatus !== contractStatuses.approvalWaiting) || (currentStatus === contractStatuses.approvalWaiting && selectedStatus === contractStatuses.expired)">
      Applying Status "{{selectedStatus | splitCamelCase}}"
    </ng-container>
  </h3>
</ng-template>

<ng-template #generalButton>
  <button mat-flat-button color="primary" disabled>
    Change Status
  </button>
</ng-template>


<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="3%">

  <h1 matDialogTitle>
    This contract needs your attention!
  </h1>

  <mat-dialog-content class="overflow-hidden">
    <ng-container *ngIf="!saving else loadingGeneral">
      <aw-general-item-detail-dialog fxFlexAlign="stretch" [inputData]="_contract"
        [disableCloseButton]="true"></aw-general-item-detail-dialog>
    </ng-container>
  </mat-dialog-content>


  <mat-form-field>
    <mat-label>Select Status</mat-label>
    <mat-select [(value)]="selectedStatus">
      <mat-option *ngFor="let status of statuses" [value]="status">

        <ng-container
          *ngIf="currentStatus === contractStatuses.approvalWaiting && (status !== contractStatuses.rejected && status !== contractStatuses.expired)">
          Accepted
        </ng-container>
        <ng-container
          *ngIf="(currentStatus !== contractStatuses.approvalWaiting) || (currentStatus === contractStatuses.approvalWaiting && (status === contractStatuses.rejected || status === contractStatuses.expired))">
          {{status | splitCamelCase}}
        </ng-container>

      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
    <button *ngIf="selectedStatus else generalButton" mat-flat-button color="primary" (click)="setStatus()"
      [disabled]="saving">
      <ng-container
        *ngIf="currentStatus === contractStatuses.approvalWaiting && (selectedStatus !== contractStatuses.rejected && selectedStatus !== contractStatuses.expired)">
        Accept Contract
      </ng-container>
      <ng-container
        *ngIf="currentStatus === contractStatuses.approvalWaiting && selectedStatus === contractStatuses.rejected">
        Reject Contract
      </ng-container>
      <ng-container
        *ngIf="(currentStatus !== contractStatuses.approvalWaiting) || (currentStatus === contractStatuses.approvalWaiting && selectedStatus === contractStatuses.expired)">
        Apply Status "{{selectedStatus | splitCamelCase}}"
      </ng-container>

    </button>
    <button mat-button matDialogClose>CLOSE</button>
  </mat-dialog-actions>
</div>